var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5391 7.14648H16.5391L10.5391 13.1465L4.53906 7.14648H9.53906V0.146484H11.5391V7.14648ZM2.53906 16.1465H18.5391V9.14648H20.5391V17.1465C20.5391 17.4117 20.4337 17.6661 20.2462 17.8536C20.0586 18.0411 19.8043 18.1465 19.5391 18.1465H1.53906C1.27385 18.1465 1.01949 18.0411 0.831956 17.8536C0.644419 17.6661 0.539063 17.4117 0.539062 17.1465V9.14648H2.53906V16.1465Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.d6dccbf6effc12a99861ba4c8de15227.svg";
export { ForwardRef as ReactComponent };